// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Hqkw","buttons":"PendingPaymentAlert_buttons__31e8b"};